import createIcon from '../../createIcon';

/**
 * @component @name Spa
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuNDkgOS42M0MxNS4zMSA2Ljg0IDE0LjE4IDQuMTIgMTIuMDYgMkM5LjkyIDQuMTQgOC43NCA2Ljg2IDguNTEgOS42M0M5Ljc5IDEwLjMxIDEwLjk3IDExLjE5IDEyIDEyLjI2QzEzLjAzIDExLjIgMTQuMjEgMTAuMzIgMTUuNDkgOS42M1pNOC45OSAxMi4yOEM4Ljg1IDEyLjE4IDguNjkgMTIuMDkgOC41NCAxMS45OUM4LjY5IDEyLjEgOC44NSAxMi4xOCA4Ljk5IDEyLjI4Wk0xMiAxNS40NUM5Ljg1IDEyLjE3IDYuMTggMTAgMiAxMEMyIDE1LjMyIDUuMzYgMTkuODIgMTAuMDMgMjEuNDlDMTAuNjYgMjEuNzIgMTEuMzIgMjEuODkgMTIgMjJDMTIuNjggMjEuODggMTMuMzMgMjEuNzEgMTMuOTcgMjEuNDlDMTguNjQgMTkuODIgMjIgMTUuMzIgMjIgMTBDMTcuODIgMTAgMTQuMTUgMTIuMTcgMTIgMTUuNDVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Spa = createIcon('Spa', [
  [
    'path',
    {
      d: 'M15.49 9.63C15.31 6.84 14.18 4.12 12.06 2C9.92 4.14 8.74 6.86 8.51 9.63C9.79 10.31 10.97 11.19 12 12.26C13.03 11.2 14.21 10.32 15.49 9.63ZM8.99 12.28C8.85 12.18 8.69 12.09 8.54 11.99C8.69 12.1 8.85 12.18 8.99 12.28ZM12 15.45C9.85 12.17 6.18 10 2 10C2 15.32 5.36 19.82 10.03 21.49C10.66 21.72 11.32 21.89 12 22C12.68 21.88 13.33 21.71 13.97 21.49C18.64 19.82 22 15.32 22 10C17.82 10 14.15 12.17 12 15.45Z',
      key: '1ithh7',
    },
  ],
]);

export default Spa;
